// extracted by mini-css-extract-plugin
export var carouselWrapper = "CustomCarousel-module--carouselWrapper--V5zhx";
export var friendsCarouselElement = "CustomCarousel-module--friendsCarouselElement--lTE+8";
export var title = "CustomCarousel-module--title--+wyuX";
export var friendsCarouselWrapper = "CustomCarousel-module--friendsCarouselWrapper--9mwDP";